import { render, staticRenderFns } from "./platformaMieszkaniowa.vue?vue&type=template&id=53a16d5f&"
import script from "./platformaMieszkaniowa.vue?vue&type=script&lang=js&"
export * from "./platformaMieszkaniowa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports